import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amountArs: number;
  className?: string;
  strikethrough?: boolean;
}
export function PriceDisplay({
  amountArs,
  className = '',
  strikethrough = false
}: PriceDisplayProps) {
  const [formattedPrice, setFormattedPrice] = useState(`$${amountArs.toLocaleString('es-AR')}`);
  useEffect(() => {
    const lang = navigator.language.toLowerCase();
    let currency = 'ARS';
    let symbol = '$';
    let convertedAmount = amountArs;
    if (lang.startsWith('en-us') || lang === 'en') {
      currency = 'USD';
      symbol = 'US$';
      convertedAmount = Math.round(amountArs / 1000);
    } else if (lang.startsWith('en-gb')) {
      currency = 'GBP';
      symbol = '£';
      convertedAmount = Math.round(amountArs / 1250);
    } else if (['de', 'fr', 'es-es', 'it', 'pt'].some(l => lang.startsWith(l))) {
      currency = 'EUR';
      symbol = '€';
      convertedAmount = Math.round(amountArs / 1100);
    }
    try {
      const formatter = new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      });
      setFormattedPrice(formatter.format(convertedAmount));
    } catch (e) {
      setFormattedPrice(`${symbol}${convertedAmount.toLocaleString()}`);
    }
  }, [amountArs]);
  if (strikethrough) {
    return <s className={className} data-id="element-133">{formattedPrice}</s>;
  }
  return <span className={className} data-id="element-134">{formattedPrice}</span>;
}